export interface DocItem {
  slug: string;
  titleKey: string;
  descriptionKey: string;
}

export interface DocCategory {
  id: string;
  titleKey: string;
  icon: string;
  descriptionKey: string;
  items: DocItem[];
}

/** Map slug (kebab-case) to translation key (camelCase) */
function slugToKey(slug: string): string {
  return slug.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
}

function item(slug: string): DocItem {
  const key = slugToKey(slug);
  return {
    slug,
    titleKey: `docs.items.${key}.title`,
    descriptionKey: `docs.items.${key}.description`,
  };
}

export const docsNavigation: DocCategory[] = [
  {
    id: "getting-started",
    titleKey: "docs.categories.gettingStarted.title",
    icon: "rocket",
    descriptionKey: "docs.categories.gettingStarted.description",
    items: [
      item("introduction"),
      item("installation"),
      item("quick-start"),
      item("configuration-basics"),
    ],
  },
  {
    id: "concepts",
    titleKey: "docs.categories.concepts.title",
    icon: "cube",
    descriptionKey: "docs.categories.concepts.description",
    items: [
      item("projects"),
      item("services"),
      item("runners"),
      item("traefik"),
    ],
  },
  {
    id: "guides",
    titleKey: "docs.categories.guides.title",
    icon: "book",
    descriptionKey: "docs.categories.guides.description",
    items: [
      item("new-project"),
      item("docker"),
      item("ssl-https"),
      item("ide-integration"),
    ],
  },
  {
    id: "reference",
    titleKey: "docs.categories.reference.title",
    icon: "code",
    descriptionKey: "docs.categories.reference.description",
    items: [
      item("config-schema"),
      item("cli"),
      item("api"),
      item("env-vars"),
    ],
  },
];

export function getDocPath(category: string, slug: string): string {
  return `/docs/${category}/${slug}`;
}

export function findDocCategory(slug: string): DocCategory | undefined {
  return docsNavigation.find((cat) => cat.items.some((item) => item.slug === slug));
}

export function findDocItem(categoryId: string, slug: string): DocItem | undefined {
  const category = docsNavigation.find((cat) => cat.id === categoryId);
  return category?.items.find((item) => item.slug === slug);
}
